<template>
    <div class="l content_right dev_management" v-loading="openAccountSet.loading">
        <div class="l tree_container">
            <div class="tools_bar">
                <el-button @click="newOrg">新增组织</el-button>
            </div>
            <el-tree :data="orgTreeData" 
            node-key="organizationcode" 
            :current-node-key="curOrgNode.organizationcode" 
            :expand-on-click-node="false" 
            :default-expanded-keys="['1']"
            :props="defaultProps" 
            @node-click="orgNodeClick"></el-tree>
        </div>
        <div class="l list_container">
            <div class="sea_bar cl">
                <div class="r ml10">
                    <div class="l inpt">
                        <el-input placeholder="帐号" v-model="filter.userName" @blur="loadListData"></el-input>
                    </div>
                </div>
                <div class="r ml10">
                    <div class="l inpt">
                        <el-input placeholder="姓名" v-model="filter.contact" @blur="loadListData"></el-input>
                    </div>
                </div>
                <div class="r ml10">
                    <el-select clearable v-model="filter.status" placeholder="状态" @change="loadListData">
                        <el-option label="启用" value="1"></el-option>
                        <el-option label="停用" value="2"></el-option>
                    </el-select>
                </div>
                <div class="r ml10">
                    <el-select clearable v-model="filter.showChildren" placeholder="是否显示下级" @change="loadListData">
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="tools_bar">
                <el-button @click="newUser">新增</el-button>
                <el-button @click="startAccount">启用</el-button>
                <el-button @click="stopAccount">停用</el-button>
                <el-button @click="deleteAccount">删除</el-button>
                <!-- <el-button @click="showResetPassword">重置密码</el-button> -->
                <!-- <el-button>导出</el-button> -->
            </div>
            <div class="table_container">
                <el-table :data="list" @selection-change="listSelect" border>
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="帐号">
                        <template scope="scope">
                            <a class="tabLink" @click="showConfigUserDia(scope.row)">{{scope.row.username1}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="contact" label="姓名"></el-table-column>
                    <el-table-column prop="orgname" label="所属部门"></el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template scope="scope">
                            <span v-if="scope.row.status == '1'">启用</span>
                            <span v-if="scope.row.status == '2'">停用</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                </el-table>
                <div class="paging">
                    <el-pagination @current-change="handleCurrentPage" :current-page.sync="paging.currentPage" :page-size="paging.pageSize" layout="total, prev, pager, next" :total="paging.totalSize"></el-pagination>
                </div>
            </div>
        </div>
        <el-dialog v-model="passwordReset.dia" title="重置密码">
            <div class="dia_container">
                <div class="form_line cl">
                    <label class="l">初始密码：</label>
                    <div class="l inpt"><el-input v-model="passwordReset.text"></el-input></div>
                </div>
                <div class="dia_btn_container">
                    <el-button @click="cancel('3')">取消</el-button>
                    <el-button type="primary" @click="savePasswordReset">保存</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog v-model="configUserData.dia" title="人员信息">
            <div class="dia_container config_user">
                <div class="form_line cl">
                    <label class="l">账号<span class="red">*</span>：</label>
                    <div class="l inpt"><el-input v-model="configUserData.userName"></el-input></div>
                    <span class="warn">请使用小写英文字母</span>
                </div>
                <div class="form_line cl">
                    <label class="l">姓名<span class="red">*</span>：</label>
                    <div class="l inpt"><el-input v-model="configUserData.contact"></el-input></div>
                </div>
                <div class="form_line cl">
                    <label class="l">所属部门<span class="red">*</span>：</label>
                    <div class="l inpt org_select">
                        <el-input v-model="configUserData.curOrgNode.organizationname" @focus="showOrgTree"></el-input>
                        <i class="el-icon-caret-bottom spe-parentOrg-down-btn placeholderColor" @click="showOrgTree"></i>
                        <el-tree class="org_tree" v-show="configUserData.orgTree" 
                            :data="orgTreeData" 
                            node-key="organizationcode" 
                            :current-node-key="configUserData.curOrgNode.organizationcode" 
                            :expand-on-click-node="false" 
                            :default-expanded-keys="['1']"
                            :props="defaultProps" 
                            @node-click="orgSelect"></el-tree>
                    </div>
                </div>
                <div class="form_line cl">
                    <label class="l">备注：</label>
                    <div class="l inpt"><el-input type="textarea" v-model="configUserData.remark"></el-input></div>
                </div>
                <div class="caption">说明：新增人员默认密码为：账号名+123456</div>
                <div class="dia_btn_container">
                    <el-button @click="cancel('1')">取消</el-button>
                    <el-button type="primary" @click="userSave">保存</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog v-model="configOrgData.dia" title="组织信息">
            <div class="dia_container">
                <div class="form_line cl">
                    <label class="l">组织名称<span class="red">*</span>：</label>
                    <div class="l inpt"><el-input v-model="configOrgData.organizationName"></el-input></div>
                </div>
                <div class="dia_btn_container">
                    <el-button @click="cancel('2')">取消</el-button>
                    <el-button type="primary" @click="orgSave">保存</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {API_ROOT} from '../../config/index'
    export default {
        data: function(){
            return {
                openAccountSet: {
                    loading: false
                },
                list: [],
                paging: {
                    currentPage: 1,
                    pageSize: 15,
                    totalSize: 30
                },
                curTenantCode: '',
                filter: {
                    userName: '',
                    contact: '',
                    status: '',
                    showChildren: ''
                },
                selection: [],
                orgTreeData: [],
                curOrgNode: {},
                defaultProps: {
                    label: 'organizationname',
                    children: 'children',
                },
                configUserData: {
                    dia: false,
                    orgCode: '',
                    userName: '',
                    contact: '',
                    remark: '',
                    orgTree: false,
                    curOrgNode: {},
                    plataccountcode: '',
                },
                configOrgData: {
                    dia: false,
                    organizationName: '',
                    parentOrgCode: ''
                },
                passwordReset: {
                    dia: false,
                    text: ''
                }
            }
        },
        created: function(){
             this.init()
        },
        methods: {
            init(){
                // 加载组织树数据
                this.loadOrgData()
                // 加载列表数据
                this.loadListData()
            },
            // 组织选择
            orgSelect(data) {
                this.configUserData.curOrgNode = data
                this.configUserData.orgTree = false
            },
            // 组织树显示隐藏
            showOrgTree() {
                this.configUserData.orgTree = !this.configUserData.orgTree
            },
            // 新建用户
            newUser() {
                this.resetConfigUserData()
                this.configUserData.curOrgNode = this.curOrgNode
                this.configUserData.dia = true
            },
            // 新建开发人员
            newOrg() {
                this.resetConfigUserData()
                this.configOrgData.organizationName = ''
                this.configOrgData.parentOrgCode = this.curOrgNode.organizationcode
                this.configOrgData.dia = true
            },
            // 人员编辑
            showConfigUserDia(data) {
                this.configUserData.plataccountcode = data.plataccountcode
                this.configUserData.orgCode = data.orgcode
                this.configUserData.userName = data.username1
                this.configUserData.contact = data.contact
                this.configUserData.remark = data.remark
                this.configUserData.curOrgNode = this.findOrgByCode(this.orgTreeData, data.orgcode)
                this.configUserData.dia = true
            },
            // 启用
            startAccount() {
                let length = this.selection.length
                if(this.selection.length > 0){
                    let _this = this
                    let codes = []
                    this.selection.forEach(function(item){
                        codes.push(item.plataccountcode)
                    })
                    this.$confirm('确认启用？')
                    .then(_ => {
                        _this.$http.post(`/platserv/platAccount/enable`,{
                            plataccountcodes: codes
                        }).then(function(res){
                            _this.$message.success('启用成功！')
                        }).catch(error => {
                            this.errorMessage(error)
                        })
                    })
                    .catch(_ => {})
                }else {
                    this.$message.warning('请选择开发人员！')
                }
            },
            // 停用
            stopAccount() {
                let length = this.selection.length
                if(this.selection.length > 0){
                    let _this = this
                    let codes = []
                    this.selection.forEach(function(item){
                        codes.push(item.plataccountcode)
                    })
                    this.$confirm('确认停用？')
                    .then(_ => {
                        _this.$http.post(`/platserv/platAccount/disable`,{
                            plataccountcodes: codes
                        }).then(function(res){
                            _this.$message.success('停用成功！')
                        }).catch(error => {
                            this.errorMessage(error)
                        })
                    })
                    .catch(_ => {})
                }else {
                    this.$message.warning('请选择开发人员！')
                }
            },
            // 删除
            deleteAccount() {
                let length = this.selection.length
                if(this.selection.length > 0){
                    let _this = this
                    let codes = []
                    this.selection.forEach(function(item){
                        codes.push(item.plataccountcode)
                    })
                    this.$confirm('确认删除？')
                    .then(_ => {
                        _this.$http.post(`/platserv/platAccount/delete`,{
                            plataccountcodes: codes
                        }).then(function(res){
                            _this.$message.success('删除成功！')
                        }).catch(error => {
                            this.errorMessage(error)
                        })
                    })
                    .catch(_ => {})
                }else {
                    this.$message.warning('请选择开发人员！')
                }
            },
            // 重置密码
            showResetPassword() {
                this.passwordReset.dia = true
            },
            // 选择租户
            listSelect(data) {
                this.selection = data
            },
            // 加载组织结构数据
            loadOrgData() {
                this.$http.post(`/platserv/organiztion/tree`,{
                    af_dimensionid: '1'
                }).then(function(res){
                    this.orgTreeData = res.data.resp_data
                    if(!this.curOrgNode.organizationcode){
                        this.curOrgNode = res.data.resp_data[0]
                    }
                }).catch(error => {
                    this.errorMessage(error)
                })
            },
            // 加载列表数据
            loadListData() {
                this.$http.post(`/platserv/platAccount/list`,{
                    codepath: this.curOrgNode.codepath,
                    page: this.paging.currentPage,
                    rows: this.paging.pageSize,
                    username: this.filter.userName,
                    contact: this.filter.contact,
                    status: this.filter.status,
                    showchildren: this.filter.showChildren === '1'
                }).then(function(res){
                    this.list = res.data.resp_data.data
                    this.paging.totalSize = res.data.resp_data.resultCount
                }).catch(error => {
                    this.errorMessage(error)
                })
            },
            // 页码切换
            handleCurrentPage(val) {
                this.paging.currentPage = val
                this.loadListData()
            },
            // 保存人员编辑
            userSave() {
                let data = {
                    plataccountcode: this.configUserData.plataccountcode ? this.configUserData.plataccountcode : undefined,
                    username1: this.configUserData.userName,
                    contact: this.configUserData.contact,
                    orgcode: this.configUserData.curOrgNode.organizationcode,
                    remark: this.configUserData.remark
                }
                if(!data.username1){
                    this.$message.warning('请填写账号！')
                    return
                }
                if(!data.contact){
                    this.$message.warning('请填写姓名！')
                    return
                }
                if(!data.username1){
                    this.$message.warning('请选择所属部门！')
                    return
                }
                this.$http.post(`/platserv/platAccount/save`,data).then(function(res){
                    this.$message.success('保存成功')
                    this.cancel('1')
                    this.loadListData()
                }).catch(error => {
                    this.errorMessage(error)
                })
            },
            // 保存组织编辑
            orgSave() {
                let data = {
                    organizationname: this.configOrgData.organizationName,
                    parentorgcode: this.configOrgData.parentOrgCode
                }
                this.$http.post(`/platserv/organiztion/save`,data).then(function(res){
                    this.$message.success('保存成功')
                    this.loadOrgData()
                    this.cancel('2')
                }).catch(error => {
                    this.errorMessage(error)
                })
            },
            //重置密码保存
            savePasswordReset() {

            },
            // 组织节点点击
            orgNodeClick(data) {
                this.curOrgNode = data
                this.loadListData()
            },
            // 重置编辑信息
            resetConfigUserData() {
                this.configUserData.plataccountcode = ''
                this.configUserData.orgCode = ''
                this.configUserData.userName = ''
                this.configUserData.contact = ''
                this.configUserData.orgName = ''
                this.configUserData.orgTree = false
                this.configUserData.remark = ''
                this.configUserData.curOrgNode = {}
            },
            cancel(key) {
                switch(key) {
                    case '1': 
                        this.configUserData.dia = false
                        break
                    case '2': 
                        this.configOrgData.dia = false
                        break
                    case '3': 
                        this.passwordReset.dia = false
                        break
                }
            },
            // 根据组织code查找组织
            findOrgByCode(org, code) {
                let _this = this
                let ret = {}
                org.forEach(function(item){
                    if(item.organizationcode === code){
                        ret = item
                    }
                    if(item.children && !ret.organizationcode){
                        ret = _this.findOrgByCode(item.children, code)
                    }
                })
                return ret
            },
            // 显示错误消息
            errorMessage(error) {
                let msg = (error.body && error.body.error_code) || error.statusText || error
                this.$message.error(msg)
            },
        }
    }
</script>


// WEBPACK FOOTER //
// Index.vue?0e9a0319